import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './settings.css';

export default function AdminSettings() {
  const API_URL = import.meta.env.VITE_API_URL;

  const getAuthHeaders = () => {
  const token = sessionStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};


  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  // --- 設定オブジェクト（3セクション分をまとめて管理） ---
  const [general, setGeneral] = useState({
    service_name: '',
    timezone: 'Asia/Tokyo',
    lang: 'ja',
    audit_retention_days: 90,
  });

  const [mail, setMail] = useState({
    from_name: '',
    from_email: '',
    smtp_host: '',
    smtp_port: 587,
    smtp_user: '',
    smtp_use_tls: true,
    // ※ パスワードは別UI/別API推奨（ここでは扱わない）
  });

  const [notify, setNotify] = useState({
    enable_email: true,
    enable_sms: false,
    daily_digest_time: '08:00',
  });


  // 取得
  const fetchSettings = async () => {
    setErr('');
    setMsg('');
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/api/admin/settings/`,
      { headers: getAuthHeaders() }
    );
      if (r.data?.success) {
        if (r.data.general) setGeneral({ ...general, ...r.data.general });
        if (r.data.mail) setMail({ ...mail, ...r.data.mail });
        if (r.data.notify) setNotify({ ...notify, ...r.data.notify });
      } else {
        setErr('設定の取得に失敗しました');
      }
    } catch (e) {
      console.error(e);
      setErr('設定の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSettings(); /* eslint-disable-next-line */ }, []);

  // 保存
  const saveAll = async () => {
    setErr('');
    setMsg('');
    setSaving(true);
    try {
      const token = await ensureCsrf();
      await axios.put(
        `${API_URL}/api/admin/settings/`,
        { general, mail, notify },
        { headers: getAuthHeaders() }
      );
      setMsg('保存しました');
    } catch (e) {
      console.error(e);
      setErr('保存に失敗しました');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h2 className="pageTitle">Admin: 設定</h2>

      {err && <div className="error-alert">{err}</div>}
      {msg && <div className="success-alert">{msg}</div>}

      {/* 全体設定 */}
      <div className="detailCard">
        <div className="detailHead">
          <div className="listTitle">全体設定</div>
          <div className="listOps">
            <button className="btn" onClick={fetchSettings} disabled={loading}>
              {loading ? '読込中…' : '再読込'}
            </button>
            <button className="btn primary" onClick={saveAll} disabled={saving}>
              {saving ? '保存中…' : '保存'}
            </button>
          </div>
        </div>

        <div className="formGrid">
          <label>
            サービス名
            <input
              type="text"
              value={general.service_name}
              onChange={(e) => setGeneral({ ...general, service_name: e.target.value })}
            />
          </label>

          <label>
            既定タイムゾーン
            <select
              value={general.timezone}
              onChange={(e) => setGeneral({ ...general, timezone: e.target.value })}
            >
              <option value="Asia/Tokyo">Asia/Tokyo</option>
              <option value="UTC">UTC</option>
              <option value="America/Los_Angeles">America/Los_Angeles</option>
              <option value="Europe/London">Europe/London</option>
            </select>
          </label>

          <label>
            既定言語
            <select
              value={general.lang}
              onChange={(e) => setGeneral({ ...general, lang: e.target.value })}
            >
              <option value="ja">日本語</option>
              <option value="en">English</option>
            </select>
          </label>

          <label>
            ログ保存日数
            <input
              type="number"
              inputMode="numeric"
              value={general.audit_retention_days}
              onChange={(e) =>
                setGeneral({ ...general, audit_retention_days: Number(e.target.value || 0) })
              }
            />
          </label>
        </div>
      </div>

      {/* メール設定 */}
      <div className="detailCard">
        <div className="detailHead">
          <div className="listTitle">メール設定</div>
          <div className="listOps">
            <button className="btn primary" onClick={saveAll} disabled={saving}>
              {saving ? '保存中…' : '保存'}
            </button>
          </div>
        </div>

        <div className="formGrid">
          <label>
            送信者名
            <input
              type="text"
              value={mail.from_name}
              onChange={(e) => setMail({ ...mail, from_name: e.target.value })}
            />
          </label>

          <label>
            送信者メール
            <input
              type="text"
              value={mail.from_email}
              onChange={(e) => setMail({ ...mail, from_email: e.target.value })}
              placeholder="no-reply@example.com"
            />
          </label>

          <label>
            SMTP ホスト
            <input
              type="text"
              value={mail.smtp_host}
              onChange={(e) => setMail({ ...mail, smtp_host: e.target.value })}
            />
          </label>

          <label>
            SMTP ポート
            <input
              type="number"
              inputMode="numeric"
              value={mail.smtp_port}
              onChange={(e) => setMail({ ...mail, smtp_port: Number(e.target.value || 0) })}
            />
          </label>

          <label>
            SMTP ユーザー
            <input
              type="text"
              value={mail.smtp_user}
              onChange={(e) => setMail({ ...mail, smtp_user: e.target.value })}
            />
          </label>

          <label>
            TLS を使用
            <div className="switchRow">
              <input
                id="smtp_tls"
                type="checkbox"
                checked={mail.smtp_use_tls}
                onChange={(e) => setMail({ ...mail, smtp_use_tls: e.target.checked })}
              />
              <label htmlFor="smtp_tls" className="inline">有効</label>
            </div>
          </label>
        </div>

        <p className="note">
          ※ SMTPパスワードはセキュリティ上、別画面で設定することを推奨です（ここでは扱いません）。
        </p>
      </div>

      {/* 通知設定 */}
      <div className="detailCard">
        <div className="detailHead">
          <div className="listTitle">通知設定</div>
          <div className="listOps">
            <button className="btn primary" onClick={saveAll} disabled={saving}>
              {saving ? '保存中…' : '保存'}
            </button>
          </div>
        </div>

        <div className="formGrid">
          <label>
            メール通知を有効
            <div className="switchRow">
              <input
                id="enMail"
                type="checkbox"
                checked={notify.enable_email}
                onChange={(e) => setNotify({ ...notify, enable_email: e.target.checked })}
              />
              <label htmlFor="enMail" className="inline">有効</label>
            </div>
          </label>

          <label>
            SMS通知を有効
            <div className="switchRow">
              <input
                id="enSms"
                type="checkbox"
                checked={notify.enable_sms}
                onChange={(e) => setNotify({ ...notify, enable_sms: e.target.checked })}
              />
              <label htmlFor="enSms" className="inline">有効</label>
            </div>
          </label>

          <label>
            デイリーダイジェスト送信時刻（HH:mm）
            <input
              type="time"
              value={notify.daily_digest_time}
              onChange={(e) => setNotify({ ...notify, daily_digest_time: e.target.value })}
            />
          </label>
        </div>
      </div>
    </div>
  );
}
